export default __webpack_public_path__ + "static/media/kickball.6d1b7aa9.jpg";